import React from "react";
import Roofman from "../../../Assets/Images/roof_man.jpeg";

const ApprovalBottom = () => {
  return (
    <div>
      <img
        src={Roofman}
        loading="lazy"
        alt="Roof Man"
        className="rounded-t-3xl"
      />
    </div>
  );
};

export default ApprovalBottom;
